// extracted by mini-css-extract-plugin
export default {"outerDiv":"GetTheApp_outerDiv__TF8LH","innerDiv":"GetTheApp_innerDiv__Wegib"};